export default __webpack_public_path__ + "static/media/2022.5e99426e.png";